// {"call":"range_history_all","data":{"network":"signet","start_timestamp":1713832677,"end_timestamp":1745368677}}

import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../api/query-keys';
import { post } from '../api/api.helpers';
import { VALIDATOR_URL } from '@/constants';
import { VaultsResponse } from '../api/types.validator';

const url = `${VALIDATOR_URL}/api/vault_list`;

// Docs: https://validator.ducatprotocol.com/api/swagger#/default/post_vault_list
export async function fetchVaultList(vault_pubkey: string) {
  const params = {
    vault_pubkey
  };
  const response: VaultsResponse = await post(
    url,
    params
  );
  // console.log(`[fetchVaultList] response:`, response)

  return response;
}

// This replaces `useQueryVaultTokens`.
// Note: wallet runes pubkey is the vault pubkey.
export function useQueryAccountVaultList(
  vaultPubkey: string | undefined,
  options = {}
) {
  return useQuery<VaultsResponse>({
    queryKey: [QueryKeys.accountVaultList, vaultPubkey],
    queryFn: async () => {
      if (!vaultPubkey) {
        throw Error('No vault pubkey provided');
      }
      return fetchVaultList(vaultPubkey);
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!vaultPubkey,
    ...options,
  });
}
